import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import "../../styles/RecipePage.css";
import { useParams } from "react-router-dom";
import {useState, useEffect} from "react";
import { useCookies } from "react-cookie";

export default function RecipePage({ dark, setDark, sidebarOpen, setSidebarOpen }) {

    const { id } = useParams();
    const toggleTheme = () => setDark(!dark);
    const [cookies, setCookie, removeCookie] = useCookies(["token"]);

    const [recette, setRecette] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRecette = async () => {
            try {

                const response = await fetch(`https://api.industriegaming.fr/api/recettes/recette/${id}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${cookies.token}`
                    }
                });

                const data = await response.json();
                setRecette(data);
            } catch (error) {
                console.error("Erreur lors du chargement de la recette :", error);
            } finally {
                setLoading(false);
            }
        };

        fetchRecette();
    }, [id]);

    if (loading) {
        return <p>Chargement de la recette...</p>;
    }

    if (!recette) {
        return <p>Recette introuvable.</p>;
    }


    return (
        <div className={`dashboard ${dark ? "dark" : ""}`}>
            <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            <div className="main">
                <Topbar
                    onToggleSidebar={() => setSidebarOpen(true)}
                    onToggleTheme={toggleTheme}
                    dark={dark}
                />

                <div className="content recipe-container">

                    {/* Header recette */}
                    <div className="recipe-header">
                        <img src={recette.image} alt={recette.titre} className="recipe-main-image" />
                        <div className="recipe-info">
                            <h1>{recette.titre}</h1>
                            <p><strong>Temps :</strong> {recette.temps}</p>
                            <p><strong>Difficulté :</strong> {recette.difficulte}</p>
                        </div>
                    </div>

                    {/* Ingrédients */}
                    <div className="card recipe-card">
                        <div className="card-header">
                            <span className="card-title">Ingrédients 🥕</span>
                        </div>
                        <ul className="ingredients-list">
                            {recette.ingredients.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>

                    {/* Étapes */}
                    <div className="card recipe-card">
                        <div className="card-header">
                            <span className="card-title">Étapes 👩‍🍳</span>
                        </div>

                        <div className="steps-list">
                            {recette.etapes.map((step, index) => (
                                <div key={index} className="step-item">
                                    <img src={step.image} alt={`Étape ${index + 1}`} className="step-image" />
                                    <div className="step-text">
                                        <div className="step-main">
                                            <span className="step-number">{index + 1}</span>
                                            <ul className="step-list">
                                                {step.texte.map((t, i) => (
                                                    <li key={i}>{t}</li>
                                                ))}
                                            </ul>
                                        </div>
                                        {/* ASTUCE DU CHEF */}
                                        {step.astuce && (
                                            <div className="chef-tip">
                                                <strong>L'ASTUCE DU CHEF :</strong>
                                                <p>{step.astuce}</p>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}
